<!-- <p>visitor-pass works!</p> -->

<div
  [ngClass]="{
    'visitor-pass-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'visitor-pass-container-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card class="visitor-pass-card">
    <mat-card-header class="visitor-pass-card-header"
      >Visitor Security Pass</mat-card-header
    >
    <mat-card-content class="visitor-pass-card-content">
      <div class="row">
        <div class="col">
          <div class="QR-container" #pdfTable>
            <qrcode
              [qrdata]="qrData"
              [allowEmptyString]="true"
              [ariaLabel]="'QR Code image with the following content...'"
              [cssClass]="'center'"
              [elementType]="'canvas'"
              [errorCorrectionLevel]="'M'"
              [title]="'Visitor Invite Data'"
              [width]="300"
            ></qrcode>
          </div>
        </div>
      </div>
      <form [formGroup]="visitorSecurityEPass">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
          rowHeight="70px"
          gutterSize="15px"
        >
          <mat-grid-tile rowspan="4">
            <div id="visitorQR" class="visitor-pass-identity">
              <mat-progress-bar
                mode="determinate"
                [value]="uploadProgressId"
              ></mat-progress-bar>
              <div class="visitor-image-container">
                <img #imageId [src]="urlID" alt="Upload ID" />
                <canvas
                  #canvasId
                  (mousedown)="startDrag($event)"
                  (mousemove)="dragPoint($event)"
                  (mouseup)="endDrag($event)"
                  (mouseleave)="endDrag($event)"
                  (touchstart)="onTouchStart($event)"
                  (touchmove)="onTouchMove($event)"
                  (touchend)="onTouchEnd($event)"
                  (touchcancel)="onTouchEnd($event)"
                ></canvas>
              </div>
              <div class="upload-button-label" *ngIf="!isAlreadUploaded">
                <label for="idpic" class="upload-button-label">Upload ID</label>
                <input
                  (click)="uploadProgressId = 0"
                  style="display: none"
                  id="idpic"
                  formControlName="identityID"
                  (change)="onUploadID($event)"
                  type="file"
                />
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile rowspan="4">
            <div class="visitor-pass-identity">
              <mat-progress-bar
                mode="determinate"
                [value]="uploadProgressProfile"
              ></mat-progress-bar>
              <div class="visitor-image-container">
                <img [src]="urlProfile" alt="Upload photo" />
              </div>
              <div class="upload-button-label" *ngIf="!isAlreadUploaded">
                <label for="profilepic" class="upload-button-label"
                  >Upload Profile</label
                >
                <input
                  (click)="uploadProgressProfile = 0"
                  style="display: none"
                  id="profilepic"
                  (change)="onUploadProfile($event)"
                  type="file"
                  name=""
                />
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="isAlreadUploaded"
            [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
          >
            <button (click)="onChangeImage()" mat-raised-button>
              Change the uploaded images
            </button>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Visitor ID</mat-label>
              <input
                readonly
                matInput
                formControlName="visitorID"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Host Id</mat-label>
              <input
                readonly
                matInput
                formControlName="hostUserId"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Host Name</mat-label>
              <input
                readonly
                matInput
                formControlName="hostName"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Visitor Email</mat-label>
              <input matInput formControlName="email" /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Contact Number</mat-label>
              <input
                readonly
                matInput
                formControlName="phoneNumber"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Visitor Address</mat-label>
              <input
                matInput
                formControlName="visitorAddress"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Vehicle Number</mat-label>
              <input
                matInput
                formControlName="carRegistration"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Purpose of Visit</mat-label>
              <mat-select formControlName="purpose">
                <mat-option value="Personal"> Personal </mat-option>
                <mat-option value="Official"> Official </mat-option>
                <mat-option value="Delivery"> Delivery </mat-option>
                <mat-option value="Meeting"> Meeting </mat-option>
                <mat-option value="Private"> Private </mat-option>
                <mat-option value="Classified"> Classified </mat-option>
              </mat-select></mat-form-field
            ></mat-grid-tile
          >
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Visit Date & Time</mat-label>
              <input
                [readonly]="true"
                matInput
                formControlName="visitDateTime"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Security Status</mat-label>
              <input [readonly]="true" matInput [value]="status" />
              <button
                mat-icon-button
                matSuffix
                [ngStyle]="
                  !!securityStatus
                    ? { 'background-color': 'green' }
                    : { 'background-color': 'red' }
                "
              >
                <mat-icon>{{
                  !!securityStatus ? "check_circle" : "close"
                }}</mat-icon>
              </button>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="showMsg"
            [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
          >
            <div
              [ngStyle]="
                isFaceMatched
                  ? { 'background-color': 'green' }
                  : { 'background-color': 'red' }
              "
              *ngIf="!isAPIRequest && (isVisitorUpload || isUploadedNewImage)"
              class="display-message"
            >
              {{ faceMatchMsg | titlecase }}
            </div>
            <div *ngIf="isAPIRequest">
              <mat-spinner [diameter]="62"></mat-spinner>
            </div>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="isVisitorUpload || isUploadedNewImage">
            <button
              (click)="onSelfVerifyVisitor()"
              [disabled]="
                disableButton ||
                profilePicture == '' ||
                identityId == '' ||
                isAPIRequest
              "
              mat-raised-button
            >
              {{ isRetry ? "Retry" : "Self Verify" }}
            </button></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="
              securityStatus == 0 && !(isVisitorUpload || isUploadedNewImage)
            "
            [colspan]="screenSize === ScreenType.Mobile ? 1 : 2"
          >
            <div class="checkbox-container">
              <mat-checkbox
                color="primary"
                formControlName="isUnverifiedStatusCheckbox"
              >
                I understand I may have to present an ID at the facility for
                security purposes.
              </mat-checkbox>
            </div>
          </mat-grid-tile>

          <mat-grid-tile
            [colspan]="
              isVisitorUpload || isUploadedNewImage
                ? 1
                : screenSize == ScreenType.Mobile
                ? 1
                : 2
            "
          >
            <button
              (click)="onSubmitSecurityVisitorPass()"
              [disabled]="
                (!showMsg && (isVisitorUpload || isUploadedNewImage)) ||
                isAPIRequest ||
                visitorSecurityEPass.invalid ||
                disableButton ||
                (securityStatus == 0 &&
                  !visitorSecurityEPass.controls.isUnverifiedStatusCheckbox
                    .value)
              "
              mat-raised-button
            >
              {{
                isVisitorUpload
                  ? "Save"
                  : !securityStatus && isVisitorUpload
                  ? "Continue without verification"
                  : "Save"
              }}
            </button></mat-grid-tile
          >
        </mat-grid-list>
      </form>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #VisitorMsgDialog>
  <h2 matDialogTitle>Hi Visitor!</h2>
  <mat-dialog-content>
    <div class="visitor-msg">
      <b
        ><i>
          You can upload your Profile picture and Government ID for seamless
          entry</i
        ></b
      >
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="false">
      {{ screenSize == ScreenType.Mobile ? "No" : "No! thanks" }}
    </button>
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>
      {{ screenSize == ScreenType.Mobile ? "Yes" : "Yes! Upload" }}
    </button>
  </mat-dialog-actions>
</ng-template>
<ng-template #VisitorDetailsSavedDialog>
  <h2 matDialogTitle>Visitor!</h2>
  <mat-dialog-content>
    <div class="visitor-msg">
      <b
        ><i> {{ error }}</i></b
      >
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #FetchingDialog>
  <h2 matDialogTitle>Please Wait!</h2>
  <mat-dialog-content>
    <div class="visitor-msg">
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>
